import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
    const navigate = useNavigate();
    const { handleGoogleCallback } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processCallback = async () => {
            // Get session_id from URL fragment
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.substring(1));
            const sessionId = params.get('session_id');

            if (!sessionId) {
                toast.error('Authentication failed - no session ID');
                navigate('/', { replace: true });
                return;
            }

            try {
                await handleGoogleCallback(sessionId);
                toast.success('Signed in with Google!');
                navigate('/', { replace: true });
            } catch (error) {
                console.error('Google auth error:', error);
                toast.error('Google sign in failed');
                navigate('/', { replace: true });
            }
        };

        processCallback();
    }, [handleGoogleCallback, navigate]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-8 h-8 animate-spin text-accent mx-auto mb-4" />
                <p className="font-body text-muted-foreground">Completing sign in...</p>
            </div>
        </div>
    );
};

export default AuthCallback;
